<template>
  <DraftMain
    :panelTitle="panelTitle"
    :initialValues="initialValues"
    :confirmDeletionFn="confirmDeletionFn"
    :closeModal="closeModal"
    :onSearch="onSearch"
    :showModal="showModal"
  >
    <template #searchHeadOperation>
      <div class="flex items-center justify-center gap-2"></div>
    </template>
    <template #searchPanel>
      <div class="flex flex-row flex-wrap w-full">
        <Field
          name="ServicesTransactions"
          v-slot="{ field, errors: errs, handleChange }"
          class="w-full"
        >
          <MultipleDropdownSearch
            :field="field"
            :errors="errs"
            :options="serviceTypeList"
            optionValue="label"
            :label="i18n.t('Services')"
            :placeholder="i18n.t('Services')"
            class="lg:w-1/2 flex-col p-2 w-full"
            direction="flex-col"
            labelClass="w-full "
            @on-selection="(item) => handleChange(item)"
          />
        </Field>
        <div class="lg:w-1/2"></div>
        <Field name="receiptNumber" v-slot="{ field, errors: errs }">
          <SimpleTextInput
            :field="field"
            :errors="errs"
            :label="$t('requestNumber')"
            direction="flex-col"
            :isRequired="false"
            class="lg:w-1/2 flex-col p-2 w-full"
          />
        </Field>
        <Field name="refundStatusId" v-slot="{ field, errors: errs, handleChange }" class="w-full">
          <SimpleDropdown
            :field="field"
            :errors="errs"
            :label="$t('requestStatus')"
            :options="paymentMethodList"
            :is-required="false"
            direction="flex-col"
            class="lg:w-1/2 flex-col p-2 w-full"
            @on-selection="
              (item) => {
                handleChange(+item?.id)
              }
            "
          ></SimpleDropdown>
        </Field>
      </div>
    </template>
    <template #searchResult>
      <DraftTable
        :isLoading="isLoading"
        :tableData="tableData"
        :initialValues="initialValues"
        :pageLength="pageLength"
        @onPageClick="onPageClick"
        @selected="selectedNumberOfRow"
        @checked="selectedRow"
        @checkOut="checkOut"
        @checkIn="checkIn"
        @delete="deleteSelected"
        :tableHeaders="tableHeaders"
        :is-show-lock-feature="false"
      >
        <template #tableRow="{ request }">
          <td
            class="px-6 py-2 text-gray-700 text-sm font-normal border-r border-brand-gray-300 text-wrap"
          >
            <input
              type="checkbox"
              @change="checkrefundRequest(request.requestNumber)"
              v-if="!authStore.isUserEstablishment && request.refundStatus == '3'"
            />
          </td>
          <td
            class="px-6 py-2 text-gray-700 text-sm font-normal border-r border-brand-gray-300 text-wrap"
          >
<button @click="isFinancialDepositExpanded = !isFinancialDepositExpanded">
  <i :class="isFinancialDepositExpanded ? 'fa-plus-circle' : 'fa-plus-circle'" class="fa"></i>
</button>
          </td>
          <td
            class="px-6 py-2 text-gray-700 text-xs font-normal border-r border-brand-gray-300 text-wrap"
          >
            {{ request?.refundStatus }}
          </td>
          <td
            class="px-6 py-2 text-gray-700 text-xs font-normal border-r border-brand-gray-300 text-wrap"
          >
            {{ request?.refundablePaidAmount }} AED
          </td>
          <td
            class="px-6 py-2 text-gray-700 text-sm font-normal border-r border-brand-gray-300 text-wrap"
          >
            <div>{{ request.beneficiaryEnglishName }}</div>
            <div>{{ request.beneficiaryArabicName }}</div>
          </td>
          <td
            class="px-6 py-2 text-gray-700 text-xs font-normal border-r border-brand-gray-300 text-wrap"
          >
            {{ request?.paymentDate }}
          </td>
        </template>

        <template #tableOperation="{ request }">
          <button
            class="bg-primary size-6 rounded-md text-white cursor-pointer text-center"
            @click.prevent="viewTicket(request)"
          >
            <i class="fa fa-eye"></i>
          </button>
        </template>
        <template #moreTableRow="{ request }">
          <tr>
            <td colspan="7">
              <div>
                <table class="w-full table-auto border-collapse border ltr:font-sans text-xs">
                  <thead>
                    <tr class="py-2 ps-3 border border-brand-gray-300 text-start">
                      <th
                        :key="key"
                        v-for="(h, key) in moreTableHeaders"
                        class="p-1 border border-gray-100"
                      >
                        {{ $t(h) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="odd:bg-brand-gray-150 ltr:font-sans text-xs">
                      <td
                        class="px-6 py-2 text-gray-700 text-sm font-normal border-r border-brand-gray-300 text-wrap"
                      >
                        {{ request.depositTypeId }}
                      </td>
                      <td
                        class="px-6 py-2 text-gray-700 text-sm font-normal border-r border-brand-gray-300 text-wrap"
                      >
                        {{ request.depositAmount }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </template>
      </DraftTable>
    </template>
  </DraftMain>
</template>
<script setup>
import { onBeforeMount, ref } from 'vue'
import { notify } from 'notiwind'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { Field } from 'vee-validate'
import DraftMain from '@/views/individual/draft/Main.vue'

import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import DraftTable from '@/views/individual/draft/DraftTable.vue'
import MultipleDropdownSearch from '@/components/SimpleForm/MultiSelect.vue'
import SimpleDropdown from '@/components/SimpleForm/Dropdown.vue'
import apiHelperService from '@/services'
import { useLookupsStore } from '@/stores/lookups'
import { useAuthStore } from '@/stores/auth'

const route = useRoute()
const router = useRouter()
const i18n = useI18n({
  messages: {
    en: {
      Services: "Services",
    },
    ar: {
      Services: "الخدمات",
    }
  }
})

const authStore = useAuthStore()
const lookupStore = useLookupsStore()

const draftId = ref([])
const showModal = ref(false)
const panelTitle = ref('feesOfRejectedRequests')
const isLoading = ref(false)
const initialValues = ref({
  currentPage: 1,
  pageSize: 10
})

const pageLength = ref(10)
const tableData = ref([])

const serviceTypeList = ref([])
const isFinancialDepositExpanded = ref(false)

const paymentMethodList = ref([
  {
    id: 1,
    label: 'Completed'
  },
  {
    id: 2,
    label: 'In Progress'
  },
  {
    id: 3,
    label: 'Available'
  }
])

const tableHeaders = ref([
  {
    value: 1,
    label: ''
  },
  {
    value: 2,
    label: ''
  },
  {
    value: 3,
    label: i18n.t('refundStatus')
  },
  {
    value: 4,
    label: i18n.t('requestNumber')
  },
  {
    value: 5,
    label: i18n.t('Beneficiary')
  },
  {
    value: 6,
    label: i18n.t('paymentdate')
  },
  {
    value: 7,
    label: ''
  }
])

const moreTableHeaders = ref(['Type', 'availableAmount', 'refundInformation'])

const viewTicket = (request) => {
  router.push(`/eid-exception-requests-view/${request.id}`)
}

const closeModal = () => {
  showModal.value = false
}

const fetchServiceTypeList = async () => {
  const res = await lookupStore.fetchLookup('/api/servicesTransactions')
  serviceTypeList.value = res.map((item) => {
    item.value = item.id
    item.code = item.id
    return item
  })
}

const requestTableData = async (value) => {
  isLoading.value = true
  const payload = {
    data: {
      ...value
    },
    currentPage: initialValues.value.currentPage,
    pageSize: pageLength.value
  }
  router.replace({ query: value })
  try {
    const response = await apiHelperService.post(
      '/api/refundRequest/searchRefundRejectedRequest',
      payload
    )
    if (response) {
      isLoading.value = false
      return response
    }
  } catch (error) {
    console.error('requestTableData', error)
  }
}

const selectedNumberOfRow = async (num) => {
  pageLength.value = num
  initialValues.value = {
    ...initialValues.value
  }
  tableData.value = await requestTableData(initialValues.value)
}

const onPageClick = async (pageNum) => {
  initialValues.value = {
    ...initialValues.value,
    currentPage: +pageNum
  }
  tableData.value = await requestTableData(initialValues.value)
}

const onSearch = async (value) => {
  tableData.value = await requestTableData(value)
}

const selectedRow = (draft) => {
  if (!draft) return
  draftId.value = draft
}

const deleteSelected = (draft) => {
  draftId.value = draft
  showModal.value = true
}

const checkOut = async () => {
  tableData.value = await requestTableData(initialValues.value)
  notify(
    {
      group: 'success',
      title: i18n.t('Success'),
      text: i18n.t('checkedOutSuccessfully')
    },
    6000
  )
}

const checkIn = async () => {
  tableData.value = await requestTableData(initialValues.value)
  notify(
    {
      group: 'success',
      title: i18n.t('Success'),
      text: i18n.t('checkedInSuccessfully')
    },
    6000
  )
}

const confirmDeletionFn = async () => {
  try {
    const payload = draftId.value
    const response = await apiHelperService.post('/api/draft/delete', payload)
    if (response) {
      tableData.value = await requestTableData(initialValues.value)
      showModal.value = false
      notify(
        {
          group: 'success',
          title: i18n.t('Success'),
          text: i18n.t('DeletedSuccessfully')
        },
        6000
      )
    }
  } catch (error) {
    console.error('confirmDeletionFn', error)
  }
}

const setDraftResponse = async () => {
  tableData.value = await requestTableData(initialValues.value)
}

onBeforeMount(async () => {
  await fetchServiceTypeList()
  await setDraftResponse()
  const searchParams = route.query
  initialValues.value = searchParams
})
</script>
<style></style>
